import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CalendarView } from 'angular-calendar';
import { MessageService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { Subscription } from 'rxjs';
import ICalendar from '../../../_interfaces/ICalendar';
import { CalendarAppointmentsService } from '../../../_services/calendars/calendar-appointments.service';
import { CalendarService } from '../../../_services/calendars/calendar.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';

@Component({
  standalone: true,
  selector: 'app-selector-multi-calendar',
  templateUrl: './selector-multi-calendar.component.html',
  styleUrls: ['./selector-multi-calendar.component.scss'],
  imports: [MultiSelectModule, FormsModule],
})
export class SelectorMultiCalendarComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  calendars: ICalendar[] = [];
  selected: { code: number; name: string }[] = [];
  options: { code: any; name: any }[] = [];
  subscriptionCalendarView: Subscription;
  subscriptionActiveSite: Subscription;

  constructor(
    public calendarsService: CalendarService,
    public session: SessionService,
    public calendarAppointments: CalendarAppointmentsService,
    public messageService: MessageService,
    public translate: TranslateService
  ) {
    super(session);
  }

  public onChange($event) {
    const calendars = this.getCalendars();
    const selectedCalendar = $event.itemValue;
    if (calendars.length == 0 && Math.random() > 1000) {
      this.selected = [selectedCalendar];
      return this.messageService.add({
        summary: this.translate.instant('MESSAGES.CALENDARS.NO_SELECT.SUMMARY'),
        detail: this.translate.instant('MESSAGES.CALENDARS.NO_SELECT.DETAIL'),
        severity: 'error',
      });
    }
    this.calendarAppointments.setCalendar$(calendars);
  }

  public getCalendars(): ICalendar[] {
    const codes = (this.selected || []).map((x) => +x.code);
    const calendars = this.calendars.filter((calendar: ICalendar) => {
      return codes.includes(+calendar.id);
    });
    return calendars;
  }

  private selectAllCalendars(): void {
    this.selected = [...this.options];
    this.calendarAppointments.setCalendar$(this.getCalendars());
  }

  private resetCalendars(): void {
    this.calendars = [];
    this.options = [];
    this.selected = [];
    this.calendarAppointments.setCalendar$([]);
  }

  private hasCalendarContext(): boolean {
    return Number(this.customers_id || 0) > 0 && Number(this.site?.id || 0) > 0;
  }

  public loadCalendars = () => {
    if (!this.hasCalendarContext()) {
      this.resetCalendars();
      return;
    }

    this.calendarsService.get(this.customers_id, this.site).subscribe({
      next: (calendars: ICalendar[]) => {
        this.calendars = calendars || [];
        this.options = this.calendars.map((c) => {
          return {
            code: c.id,
            name: c.name,
          };
        });
        this.selectAllCalendars();
      },
      error: () => {
        this.resetCalendars();
      },
    });
  };

  ngOnDestroy(): void {
    this.subscriptionCalendarView?.unsubscribe();
    this.subscriptionActiveSite?.unsubscribe();
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadCalendars();

    this.subscriptionActiveSite = this.session.getSite$().subscribe((site) => {
      if (Number(site?.id || 0) > 0) {
        this.loadCalendars();
      } else {
        this.resetCalendars();
      }
    });

    this.subscriptionCalendarView = this.calendarAppointments
      .getCalendarView$()
      .subscribe((view: CalendarView) => {
        if (view == CalendarView.Day) {
          this.selectAllCalendars();
        } else {
          this.loadCalendars();
        }
      });
  }
}
